import { ROUTES } from "@/router/route-consts";

export default {
    name: "Halls",
    setup () {
        const halls = [
            { name: "Братислава", disabled: false, url: "sportaq_lobby1" },
            { name: "Супутник", disabled: false, url: "sportaq_lobby2" },
            { name: "Кремінь", disabled: true, url: "/" },
            { name: "Прикарпаття", disabled: true, url: "/" },
            { name: "Ribas Rooms Lutsk", disabled: true, url: "/" },
            { name: "Apartel Uzhhorod", disabled: true, url: "/" }
        ];
        return {
            halls,
            ROUTES
        };
    }
};
